import { type ReactNode, useMemo } from 'react';

import { CardDescription } from '@/microfrontends/listing/shared/components/CardDescription';
import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors';

import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';

export function DescriptionContainer(): ReactNode {
  const {
    description,
    extendedProperties: { offerServices },
  } = useCardOfferDataContext();
  const isNarrow = useListingLayoutIsNarrowSelector();

  const rowsAmount = useMemo<number>(() => {
    const isFat = Boolean(offerServices?.isTop3);

    switch (true) {
      case isFat && !isNarrow:
        return 4;
      case !isFat && isNarrow:
        return 1;
      default:
        return 2;
    }
  }, [isNarrow, offerServices?.isTop3]);

  return <CardDescription description={description} rowsAmount={rowsAmount} />;
}
